/** Simple seeded PRNG (mulberry32) for reproducibility */
let seed = Date.now();

function mulberry32(a) {
  return function () {
    a |= 0; a = a + 0x6D2B79F5 | 0;
    let t = Math.imul(a ^ a >>> 15, 1 | a);
    t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t;
    return ((t ^ t >>> 17) >>> 0) / 4294967296;
  };
}

let rng = mulberry32(seed);

export function setSeed(s) {
  seed = s;
  rng = mulberry32(seed);
}

/** Random float [0, 1) */
export function random() {
  return rng();
}

/** Random integer [min, max] inclusive */
export function randomInt(min, max) {
  return Math.floor(rng() * (max - min + 1)) + min;
}

/** Random float [min, max) */
export function randomFloat(min, max) {
  return min + rng() * (max - min);
}

/** Pick a random element from an array */
export function randomFrom(arr) {
  return arr[Math.floor(rng() * arr.length)];
}
